const WinlosesTypes = {
    FETCH_START:    '[ONNA][WINLOSES] FETCH START',
    FETCH_SUCCESS:  '[ONNA][WINLOSES] FETCH SUCCESS',
    FETCH_FAILURE:  '[ONNA][WINLOSES] FETCH FAILURE'
};

export default WinlosesTypes;